import GroupFiltersCard from "./GroupFiltersCard";

export default GroupFiltersCard;
